import { collection, get, all, update } from "typesaurus"
import { Assessments, Activity, Role, GeoState } from "../types"

export interface Educator {
  id: string
  created: number
  createdBy?: string
  lastModified: number
  firstName: string
  lastName: string
  fullName: string
  email?: string
  username?: string
  validated: boolean
  role: Role
  isTeacher: boolean
  state: GeoState
  schoolDistrict: string
  school: string
  classes: { [key: string]: boolean }
  licenses: { [key: string]: boolean }
  assessments?: Assessments
  activity: Activity
  title?: string
  sfid?: string
  deleted?: boolean
  sourceId?: string
  emailNotification?: boolean
  schools?: string[]
  districts?: string[]
  loginSource?: string
}

const collection_ref = collection<Educator>("educators")

export const getEducatorById = (id: string) => {
  return get(collection_ref, id)
}

export const getAllEducators = () => {
  return all(collection_ref)
}

export const updateEducatorById = (id: string, newVals: Partial<Educator>) => {
  return update(collection_ref, id, newVals)
}
